import React from 'react'
import { defaultProps } from './index'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'
import CtaToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/CtaToolbarSection'
import LayoutToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/LayoutToolbarSection'

export const BrandsSectionSettings = (settingsProps) => {
  const themeOpts = [
    { label: 'Bianco', value: 'white' },
    { label: 'Grigio chiaro', value: 'neutral10' },
    { label: 'Grigio', value: 'neutral20' },
  ]

  return (
    <>
      <ToolbarSection title="Settings" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="theme"
          type="select"
          options={themeOpts}
          label="Sfondo"
          defaultValue={defaultProps['theme']}
        />
      </ToolbarSection>
      {!settingsProps.floating && (
        <>
          <CtaToolbarSection defaultProps={defaultProps} />
          <LayoutToolbarSection defaultProps={defaultProps} />
        </>
      )}
    </>
  )
}

export const BrandsSectionFloatingSettings = () =>
  React.createElement(BrandsSectionSettings, { floating: true })
